// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/MajorWishList/Choose.less
// module id = 935
// module chunks = 0